export default "__VITE_ASSET__dCO7ln7M__"